var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPencil = function SvgEditPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    d: "M1.473 15.375a.625.625 0 0 1-.617-.717l.75-5.058a.6.6 0 0 1 .175-.35l8.225-8.15c.8-.8 2.109-.8 2.917 0l2.317 2.3a2.03 2.03 0 0 1 0 2.9l-8.184 8.108a.67.67 0 0 1-.35.175l-5.15.784h-.091zm1.342-5.383-.592 4.016 4.108-.625 8.034-7.966c.15-.15.233-.35.233-.567a.8.8 0 0 0-.233-.567l-2.317-2.3a.825.825 0 0 0-1.158 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    d: "M12.365 8.9a.62.62 0 0 1-.441-.184L7.574 4.4a.62.62 0 0 1 0-.884.62.62 0 0 1 .883 0l4.35 4.317a.62.62 0 0 1 0 .883.62.62 0 0 1-.442.184"
  })));
};
export default SvgEditPencil;